import React from "react";
import { Typewriter } from "react-simple-typewriter";

function Type() {
  return (
    <span className="typewriter-text">
      <Typewriter
        words={[
          "Software Developer",
          "Front End Developer",
          "ML and AI Enthusiast",
        ]}
        loop
        cursor
        cursorStyle="|"
        typeSpeed={70}
        deleteSpeed={50}
        delaySpeed={1000}
      />
    </span>
  );
}

export default Type;
